import { gql } from 'apollo-boost';

export const CLEAR_FOLDER_LAST_VIEWED = gql`
    mutation($data: ClearFolderLastViewedInput!) {
        clearFolderLastViewed(data: $data) {
            id
            title
            parent
            owner
            before
            isPinned
            pinnedRank
            lastViewedAt
            lastMovedAt
            deletedAt
        }
    }
`;
